<template>
  <div class="msg-input-container">
    <el-input
      :value="selfData"
      @change="change"
      @input="input"
      @blur="blur"
      @focus="focus"
      v-bind="$attrs"
      ref="input"
      class="msg-input"
      size="small"
      :placeholder="placeholder"
      @keyup.enter.native="sendMsg"
    ></el-input>
    <el-button
      type="text"
      size="mini"
      v-loading="loading"
      element-loading-spinner="el-icon-loading"
      element-loading-customClass="send-loading"
      @click="sendMsg"
    >
      <ig-icon
        name="fasong"
        v-show="!loading"
      ></ig-icon>
    </el-button>
  </div>
</template>

<script>
// 一个发送消息的组件
import suffix from "@/components/iglobalwin/formComponents/SkySuffix.vue";
import formStore from "@/mixins/formStore.js";

export default {
  components: {
    suffix
  },
  props: {
    placeholder: ""
  },
  mixins: [formStore],
  data() {
    return {
      val: "",
      loading: false
    };
  },
  methods: {
    change(val) {
      this.selfData = val;
      this.$emit("change", this.selfData);
    },
    input(val) {
      this.selfData = val;
    },
    blur(ev) {
      this.$emit("blur");
    },
    focus(ev) {
      this.$emit("focus");
    },
    sendMsg() {
      this.loading = true;
      this.$emit(
        "send",
        () => {
          this.selfData = "";
        },
        () => {
          this.loading = false;
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.msg-input-container {
  display: flex;
  .msg-input {
    margin-right: 20px;
  }
}
</style>

<style>
.msg-input-container .msg-input .el-input__inner {
  background: rgba(237, 237, 237, 1);
  border-radius: 20px;
  border-color: #eee;
}
.msg-input-container .msg-input .el-input__inner:focus {
  border-color: #91b1f5;
}
.msg-input-container .el-button--text {
  color: #9b9b9b;
  width: 20px;
  height: 21px;
}
.msg-input-container .el-button--text:focus,
.msg-input-container .el-button--text:hover {
  color: #66b1ff;
  border-color: transparent;
  background-color: transparent;
}
.msg-input-container .el-loading-spinner {
  margin-top: -3px;
  font-size: 18px;
}
</style>
